import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Box, Snackbar, SnackbarCloseReason } from '@mui/material';
import React, { useState } from 'react';

import { AlertIconStyles, AlertStyles } from '@/components/ui/alerts/alert.styles.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

type AlarmType = 'error' | 'success';

type Props = {
  handleAlertShown: () => void;
  message: string | null;
  type: AlarmType;
};

export const Alert: React.FC<Props> = props => {
  const { handleAlertShown, message, type } = props;
  const [visible, setVisible] = useState(true);
  const { t } = useTranslationWithPrefix('alerts');
  const defaultMessage = type === 'error' ? 'error' : 'success';
  const icon = type === 'error' ? <ErrorOutlineOutlinedIcon /> : <CheckCircleOutlineOutlinedIcon />;

  const handleHide = (
    _event: Event | React.SyntheticEvent<unknown, Event>,
    reason: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setVisible(false);
    handleAlertShown();
  };

  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      autoHideDuration={3000}
      className={type}
      onClose={handleHide}
      open={visible}
      style={{ top: '70px' }}
    >
      <Box className={type} sx={AlertStyles}>
        <Box sx={AlertIconStyles}>{icon}</Box>
        {message ?? t(defaultMessage)}
      </Box>
    </Snackbar>
  );
};
